<template>
  <div>
    <div v-for="person in people" :key="person.id">
      <AppShowPersonWithDetails
        v-if="!showAthleteNameOnly && !showNameOnly"
        :person="person"
        :profile-link="profileLink"
        :details-to-show="detailsToShow"
        :paradressage-grade="paradressageGrade"
      >
        <template #personNameAdditionalDetails>
          <slot name="personNameAdditionalDetails" v-bind="{ person }" />
        </template>
        <template #personAdditionalDetails>
          <slot name="personAdditionalDetails" v-bind="{ person }" />
        </template>
      </AppShowPersonWithDetails>

      <AppShowAthleteName
        v-else-if="showAthleteNameOnly"
        :athlete="person"
        :name-only="ignoreClub"
        :paradressage-grade="paradressageGrade"
      >
        <template #personNameAdditionalDetails>
          <slot name="personNameAdditionalDetails" v-bind="{ person }" />
        </template>
        <template #personAdditionalDetails>
          <slot name="personAdditionalDetails" v-bind="{ person }" />
        </template>
      </AppShowAthleteName>

      <AppShowPersonNameWithIdentifiers
        v-else-if="showNameWithIdentifiers"
        :person="person"
      />
      <AppShowPersonName
        v-else
        :paradressage-grade="paradressageGrade"
        :person="person"
      >
        <template #appendPersonName>
          <slot name="appendPersonName" v-bind="{ person }" />
        </template>
        <template #personNameAdditionalDetails>
          <slot name="personNameAdditionalDetails" v-bind="{ person }" />
        </template>
        <template #personAdditionalDetails>
          <slot name="personAdditionalDetails" v-bind="{ person }" />
        </template>
      </AppShowPersonName>
    </div>
  </div>
</template>
<script>
import gql from "fraql";
import AppShowPersonWithDetails from "./AppShowPersonWithDetails.vue";
import AppShowPersonName from "./AppShowPersonName.vue";
import AppShowAthleteName from "./AppShowAthleteName.vue";
import AppShowPersonNameWithIdentifiers from "./AppShowPersonNameWithIdentifiers.vue";

export default {
  name: "AppShowPeopleList",
  components: {
    AppShowPersonWithDetails,
    AppShowPersonName,
    AppShowAthleteName,
    AppShowPersonNameWithIdentifiers
  },
  props: {
    people: {
      type: Array,
      default() {
        return [];
      }
    },
    detailsToShow: {
      type: Array,
      default() {
        return [];
      }
    },
    ignoreClub: {
      type: Boolean,
      default: false
    },
    profileLink: {
      type: Boolean,
      default: false
    },
    paradressageGrade: {
      type: String,
      default: null
    },
    showAthleteNameOnly: {
      type: Boolean,
      default: false
    },
    showNameOnly: {
      type: Boolean,
      default: false
    },
    showNameWithIdentifiers: {
      type: Boolean,
      default: false
    }
  },
  fragments: {
    person: gql`
      fragment _ on Person {
         ${AppShowPersonWithDetails.fragments.person}
      }
    `,
    athlete: gql`
     fragment _ on Person {
       ${AppShowAthleteName.fragments.athlete}
     }
    `,
    basicPerson: gql`
      fragment _ on Person {
        ${AppShowPersonName.fragments.person}
      }
    `
  }
};
</script>
